module.exports = __webpack_public_path__ + "static/media/store_web.168018eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/carouselPropositions/store_web.png
// module id = 2182
// module chunks = 0